// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__13v6S","buttons":"RemoveExpirationActionButtons_buttons__14kIB"};